import { createApp } from 'vue'
import AdminApp from './AdminApp.vue'
import CartApp from './CartApp.vue'
import adminRouter from './router/admin'
import cartRouter from './router/cart'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import { createPinia } from 'pinia'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas, fab)
import { mountProductPage } from '@/product/mountProductPage'
import cookieService from '@/services/cookie-service'
import { getBadge, updateBadge } from '@/product/badge'
import { CartIconSvg } from '@/product/cartIcon'
import { onReady } from '@/product/onReady'
import useProductService from './services/product-service'
import { useToast } from './composables/useToast'

const pinia = createPinia()
const productService = useProductService()
const toast = useToast()

const updateCartCountEvent = new Event("updateCartCount")

const apps = [{
    id: 'app-admin',
    app: AdminApp,
    router: adminRouter,
    authAdmin: true
}, {
    id: 'app-cart',
    app: CartApp,
    router: cartRouter,
    authAdmin: false
}]

for (const app of apps) {
    if (document.getElementById(app.id)) {
        createApp(app.app)
            .use(pinia)
            .use(app.router)
            .component('font-awesome-icon', FontAwesomeIcon)
            .provide('authAdmin', app.authAdmin)
            .mount(`#${app.id}`)
    }
}

const product = mountProductPage()


onReady(async () => {
    async function getCartTotalQuantity() {
        const headers = new Headers()
        headers.append('Content-type', 'application/json')
        headers.append('X-XSRF-TOKEN', cookieService.getCookie('XSRF-TOKEN') ?? '')
        const request = new Request(`${process.env.VUE_APP_API_HOST}/cart`, {
            method: 'GET',
            headers,
            credentials: 'include'
        })
        const result = await (await fetch(request)).json()
        const configItems = result?.items?.config
        const webItems = result?.items?.website
        const contractItems = result?.items?.contractPrice
        const allItems = [...configItems, ...webItems, ...contractItems]
        const totalItems = allItems.reduce((prev, cur) => prev + cur.quantity, 0)
        return totalItems
    }
    
    const menuItems = document.querySelectorAll('li.menu-item a')
    let cartMenuItem: HTMLAnchorElement | null = null
    menuItems.forEach(elm => {
        const el = elm as HTMLAnchorElement
        if (el.innerText.toLowerCase() === 'cart') {
            cartMenuItem = el
        }
    })
    
    setTimeout(async function () {
        const headers = new Headers()
        headers.append('Content-type', 'application/json')
        headers.append('X-XSRF-TOKEN', cookieService.getCookie('XSRF-TOKEN') ?? '')
        const request = new Request(`${process.env.VUE_APP_API_HOST}/auth/is-auth`, {
            method: 'GET',
            headers,
            credentials: 'include'
        })
        const result = await (await fetch(request)).json()
        if (cartMenuItem) {
            updateCartMenuItem(result.isAuthenticated)
        }
    }, 1)

    async function updateCartMenuItem(authenticated: boolean) {
        const inner = authenticated ? 'Cart' : 'Login'
        let result = ''
        if (authenticated) {
            const count = await getCartTotalQuantity()
            const badge = getBadge(count)
            result = CartIconSvg
            result += '&nbsp;' + badge.outerHTML
            result += '&nbsp;' + inner
        } else {
            result = inner
        }
        cartMenuItem!.innerHTML = result
    }

    document.addEventListener("updateCartCount", async () => {
        const cartCount = await getCartTotalQuantity()
        updateBadge(cartCount)
    })
})

export function dispatchUpdateCartCountEvent() {
    document.dispatchEvent(updateCartCountEvent)
}

document.addEventListener("clearProductCache", async (e: any) => {
    const productId = e.detail.productId
    const result = await productService.clearProductCache(productId.toString())
    if(result.success) toast.success(`Cache cleared for product #${productId}!`)
    else toast.error("Error clearing cached product data.")
})
